import { render, staticRenderFns } from "./vacations.vue?vue&type=template&id=0794c84c"
import script from "./vacations.vue?vue&type=script&lang=js"
export * from "./vacations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports